import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[contributor-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ContributorValidatorDirective, multi: true }]
})
export class ContributorValidatorDirective implements Validator {

  validate(c: FormControl): ValidationErrors {

    // const isValid = c.value && c.value.ContributorRole && c.value.KeyNames;
    const isValid = c.value && c.value.ruolo && c.value.nomecompleto;

    // console.log('contributor-validator', c, isValid);

    const message = {
      'contributor': {
        'message': 'Specificare il ruolo e il nome dell\'autore'
      }
    };
    return isValid ? null : message;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/contributor-validator.directive.ts